import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import AuthShell, { inputClass, inputShadow } from "@/components/AuthShell";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
      navigate("/", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      testId="login-page"
      title="WELCOME BACK"
      subtitle="Parent log in"
    >
      <form onSubmit={submit} className="space-y-3">
        <input
          data-testid="login-email-input"
          type="email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          className={inputClass}
          style={inputShadow}
          required
        />
        <input
          data-testid="login-password-input"
          type="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          className={inputClass}
          style={inputShadow}
          required
        />
        {error && (
          <div
            data-testid="login-error"
            className="font-display text-base text-white rounded-2xl border-4 border-navy px-4 py-2"
            style={{ backgroundColor: "#FF5A36" }}
          >
            {error}
          </div>
        )}
        <button
          data-testid="login-submit-btn"
          type="submit"
          disabled={busy}
          className="chunky-btn w-full py-4 text-2xl text-navy disabled:opacity-50"
          style={{ backgroundColor: "#7CE645" }}
        >
          {busy ? "LOGGING IN..." : "LOG IN"}
        </button>
      </form>

      <div className="mt-5 flex flex-col gap-2 font-display text-base">
        <Link
          data-testid="forgot-password-link"
          to="/forgot-password"
          className="text-navy/70 underline"
        >
          Forgot your password?
        </Link>
        <Link data-testid="go-signup-link" to="/signup" className="text-navy underline">
          New here? Create an account
        </Link>
        <Link data-testid="how-it-works-link" to="/how-it-works" className="text-navy/70 underline">
          How it works
        </Link>
      </div>
    </AuthShell>
  );
}
